import { render, staticRenderFns } from "./OwnHome.vue?vue&type=template&id=adcfb3c6&"
import script from "./OwnHome.vue?vue&type=script&lang=js&"
export * from "./OwnHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports